"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TravelBotChatSingleDialogGeneric: ()=>TravelBotChatSingleDialogGeneric
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const CustomMarkdown_js_namespaceObject = require("./components/MarkdownComponent/CustomMarkdown.js");
const MessageFooterWithVote_js_namespaceObject = require("./components/MessageFooter/MessageFooterWithVote.js");
const misc_js_namespaceObject = require("./constants/misc.js");
const prompt_js_namespaceObject = require("./constants/prompt.js");
const ChatbotDataContext_js_namespaceObject = require("./context/ChatbotDataContext.js");
const StreamingStatusContext_js_namespaceObject = require("./context/StreamingStatusContext.js");
const useStreamingText_js_namespaceObject = require("./hooks/useStreamingText.js");
const external_TravelBotLogoImage_js_namespaceObject = require("./TravelBotLogoImage.js");
const sanitizeText_js_namespaceObject = require("./utils/sanitizeText.js");
const CustomChatMessage = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.ChatMessage).withConfig({
    displayName: "TravelBotChatSingleDialogGeneric__CustomChatMessage"
})([
    "overflow-wrap:anywhere;& div:nth-child(2){width:fit-content;}"
]);
const ChatMessageWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "TravelBotChatSingleDialogGeneric__ChatMessageWrapper"
})([
    "p{margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;margin-bottom:8px;font-size:",
    "px;}p:last-child{margin-bottom:0;}strong{font-weight:bold;}"
], (props)=>props.theme.fontSizes[props.fontSize]);
const TravelBotChatSingleDialogGeneric = (props)=>{
    const { isMobile } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const isStreaming = (0, external_react_namespaceObject.useContext)(StreamingStatusContext_js_namespaceObject.StreamingStatusContext);
    const { message } = props;
    const { content, role } = message;
    const { settledText, streamingText } = (0, useStreamingText_js_namespaceObject.useStreamingText)(content, isStreaming);
    const isAssistant = role === misc_js_namespaceObject.ROLE_ASSISTANT;
    const MessageIcon = function() {
        if (isAssistant) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage, {});
        return null;
    };
    const footerMessagePrefix = isAssistant ? 'Penny' : '';
    const messageContent = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageWrapper, {
        fontSize: 2,
        children: isAssistant ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                settledText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomMarkdown_js_namespaceObject.CustomMarkdown, {
                    isStreaming: false,
                    children: settledText
                }),
                streamingText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomMarkdown_js_namespaceObject.CustomMarkdown, {
                    isStreaming: true,
                    children: streamingText
                })
            ]
        }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomMarkdown_js_namespaceObject.CustomMarkdown, {
            isStreaming: false,
            children: (0, sanitizeText_js_namespaceObject.sanitizeText)(content)
        })
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomChatMessage, {
        "data-testid": isAssistant ? 'pennyCCM' : 'userCCM',
        mb: isAssistant ? '40px' : 4,
        ml: isAssistant ? '' : 'auto',
        variation: isAssistant ? 'initial' : 'outgoing',
        Icon: MessageIcon,
        message: messageContent,
        footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooterWithVote_js_namespaceObject.MessageFooterWithVote, {
            footerMessagePrefix: footerMessagePrefix,
            isNotUser: isAssistant,
            isGreetingMessage: prompt_js_namespaceObject.GREETING_MESSAGE === content,
            isMobile: isMobile,
            message: message
        })
    });
};
exports.TravelBotChatSingleDialogGeneric = __webpack_exports__.TravelBotChatSingleDialogGeneric;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TravelBotChatSingleDialogGeneric"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
